import { TaskManagerList } from "./taskManagmentList";
import { Nav } from "./navbar/nav";
import { TaskManagmentTodoList } from "./taskManagmentTodoList";
import { useState } from "react";
import { QuickAdd } from "./quickAdd";
import { Backdrop } from "@material-ui/core";

export const TaskManagmentPage = () => {
  const [selected, setSelected] = useState(0);
  const [quickAdd, setQuickAdd] = useState();

  return (
    <div>
      <Nav />
      <div id="task-managment-container">
        <TaskManagerList
          setQuickAdd={setQuickAdd}
          setSelected={setSelected}
          selected={selected}
        />
        <TaskManagmentTodoList setQuickAdd={setQuickAdd} selected={selected} />
      </div>
      {quickAdd && (
        <Backdrop open={true} id="full-backdrop">
          <QuickAdd
            setQuickAdd={setQuickAdd}
            list={quickAdd}
            forceNeedAccept={true}
          />
        </Backdrop>
      )}
    </div>
  );
};
